import React, { useState } from "react";
import { Button, TextField, Box, Typography, Paper, Autocomplete } from "@mui/material";
import { ParticipantFilter } from "../../app/models/participantFilter";
import { useStore } from "../../app/stores/store";
import { useTranslation } from "react-i18next";

interface Props {
  activityId: string;
}

export default function ParticipantAutocomplete({ activityId }: Props) {
  const [participants, setParticipants] = useState<
    ParticipantFilter[] | undefined
  >([]);
  const participantStore = useStore((s) => s.participantStore);
  const modalStore = useStore((s) => s.modalStore);
  const { searchParticipant, createParticipant } = participantStore;
  const [selectedParticipant, setSelectedParticipant] = useState<any>(null);
  const { t } = useTranslation();

  const handleSearchChange = async (searchQuery: string) => {
    const response = await searchParticipant(searchQuery);
    setParticipants(response);
  };

  const participantOptions = participants?.map((participant) => ({
    key: participant.id,
    text: `${participant.name}`,
    value: participant.id,
  }));

  const handleOnChange = (_event: any, value: any) => {
    setSelectedParticipant(value);
  };

  const handleCreateParticipant = async () => {
    if (selectedParticipant) {
      await createParticipant({
        id: selectedParticipant.value,
        activityId: activityId,
      });
      modalStore.closeModal();
    }
  };

  return (
    <>
      <Typography variant="h5" component="h2" sx={{ mb: 2 }}>
        {t("participants.addParticipant")}
      </Typography>
      <Box>
        <Paper sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            {t("participants.addParticipant")}
          </Typography>
          <Autocomplete
            options={participantOptions || []}
            getOptionLabel={(option) => option.text || ""}
            value={selectedParticipant || null}
            onChange={handleOnChange}
            onInputChange={(_event, value) => handleSearchChange(value)}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("participants.searchPlaceholder")}
                variant="standard"
                fullWidth
                sx={{ mb: 2 }}
              />
            )}
          />
          <Box sx={{ textAlign: "right", mt: 2 }}>
            <Button
              variant="contained"
              color="success"
              onClick={handleCreateParticipant}
              disabled={!selectedParticipant}
            >
              {t("participants.addParticipant")}
            </Button>
          </Box>
        </Paper>
      </Box>
    </>
  );
}
